import { MutationTree } from "vuex";
import { DrinkingState } from "./types";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { UpdateDrinkForDay, UpdateDrinkDetails } from "./actions";
import { setWeeklyDrinkingDaysReducer } from "./reducers/setWeeklyDrinkingDays";
import { updateDrinkQuantityReducer } from "./reducers/updateDrinkQuantity";
import { updateAverageDayDrinkQuantityReducer } from "./reducers/updateAverageDayDrinkQuantity";
import { BingeFrequency } from "@dcc/types/bingeFrequency";
import { DayOfWeek } from "@dcc/types/dayOfWeek";

export const mutationNames = {
  UPDATE_DRINKINGFREQ: "updateDrinkingFreq",
  UPDATE_MONTHLYDRINKINGDAYS: "updateMonthlyDrinkingDays",
  UPDATE_WEEKLYDRINKINGDAYS: "updateWeeklyDrinkingDays",
  UPDATE_WEEKDAYDRINKQUANTITY: "updateWeekdayDrinkQuantity",
  UPDATE_BINGEFREQUENCY: "updateBingeFrequency",
  UPDATE_AVERAGEDAYDRINKQUANTITY: "updateAverageDayDrinkQuantity",
  UPDATE_TARGETPERCENTAGE: "updateTargetPercentage",
  UPDATE_DRINKFREEDAYS: "updateDrinkFreeDays"
};

export const mutations: MutationTree<DrinkingState> = {
  [mutationNames.UPDATE_DRINKINGFREQ](state, payload: DrinkFrequency) {
    state.drinkFrequency = payload;
  },
  [mutationNames.UPDATE_MONTHLYDRINKINGDAYS](state, payload: number) {
    state.monthlyDrinkingDays = payload;
  },
  [mutationNames.UPDATE_WEEKLYDRINKINGDAYS](state, payload: number[]) {
    state.drinkingDays = setWeeklyDrinkingDaysReducer(
      state.drinkingDays,
      payload
    );
  },
  [mutationNames.UPDATE_WEEKDAYDRINKQUANTITY](
    state,
    payload: UpdateDrinkForDay
  ) {
    state.drinkingDays = updateDrinkQuantityReducer(
      state.drinkingDays,
      payload
    );
  },
  [mutationNames.UPDATE_BINGEFREQUENCY](state, payload: BingeFrequency) {
    state.bingeFrequency = payload;
  },
  [mutationNames.UPDATE_AVERAGEDAYDRINKQUANTITY](
    state,
    payload: UpdateDrinkDetails
  ) {
    state.averageDrinkingDay = updateAverageDayDrinkQuantityReducer(
      state.averageDrinkingDay,
      payload
    );
  },
  [mutationNames.UPDATE_TARGETPERCENTAGE](state, payload: number | undefined) {
    state.targetPercentage = payload;
  },
  [mutationNames.UPDATE_DRINKFREEDAYS](state, payload: DayOfWeek[]) {
    state.drinkFreeDays = payload;
  }
};
